//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
    name: "FaqMyOrder",
    computed: {
        ...mapGetters({
            isGuest: 'user/isGuest'
        }),
        buttons() {
            return (AppConfig?.faq?.myOrderButtons ?? [])
        }
    }
}
